import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Escalating reassurance shown on the global ngx-ui-loader text while a
// long-running SAP asset fetch is in flight (some sites, e.g. the big
// corporate towers, can take several minutes to sync). Empty for the first
// 30s so quick loads never show it at all.
const MESSAGE_LADDER: Array<string> = [
  'Looks like this site has a lot of assets - please give it a bit more time.',
  "Still pulling everything through - hang tight, this one's a big site.",
  'Almost there. Big buildings just take a little longer to sync from SAP.',
  "Thanks for your patience - we're nearly done gathering all the assets.",
  "Just a little longer now - this is one of the larger sites, but we've got it."
];

const STEP_MS = 30000;

@Injectable({
  providedIn: 'root'
})
export class LoadingMessageService {
  private readonly _text = new BehaviorSubject<string>('');
  public readonly text$ = this._text.asObservable();
  private intervalHandle: ReturnType<typeof setInterval> | undefined;

  public startEscalating(): void {
    this.clearTimer();
    this._text.next('');
    let step = 0;
    this.intervalHandle = setInterval(() => {
      this._text.next(MESSAGE_LADDER[Math.min(step, MESSAGE_LADDER.length - 1)]);
      step++;
    }, STEP_MS);
  }

  public stop(): void {
    this.clearTimer();
    this._text.next('');
  }

  private clearTimer(): void {
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
      this.intervalHandle = undefined;
    }
  }
}
